import React, { useState, useEffect } from 'react';

import { Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { FormTextField } from 'components/forms/FormikFields';
import { Formik, Form } from 'formik';

import ServiceCategoryService from 'services/ServiceCategoryService';
import showNotification from 'commons/helpers/showNotification';
import yup from 'commons/validations';

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  actionsRoot: {
    justifyContent: 'space-between',
  },
}));

const schema = yup.object().shape({
  name: yup.string().min(2).max(150).required(),
});

const DEFAULT_INIT_VALUES = {
  name: '',
};

// COMPONENT
function ServiceCategoryFormModal({
  serviceCategoryId,
  open,
  defaultName,
  onClose,
  onCreateCallback,
  onUpdateCallback,
}) {
  const { classes } = useStyles();
  const [initialValues, setInitialValues] = useState(DEFAULT_INIT_VALUES);

  useEffect(() => {
    async function initData() {
      if (serviceCategoryId) {
        const resp = await ServiceCategoryService.getById(serviceCategoryId);
        setInitialValues({
          ...resp,
          timestamp: new Date().getTime(),
        });
      } else {
        setInitialValues({
          name: defaultName ?? '',
          timestamp: new Date().getTime(),
        });
      }
    }
    if (open) {
      initData();
    }
  }, [serviceCategoryId, open, defaultName]);

  const myHandleSubmit = (values, actions) => {
    const submission = {
      ...values,
    };
    ServiceCategoryService.save(submission)
      .then((updatedObj) => {
        if (values.id > 0) {
          onUpdateCallback(updatedObj);
          showNotification('success', 'Atualizado com sucesso.');
        } else {
          onCreateCallback(updatedObj);
          showNotification('success', 'Criado com sucesso.');
        }
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  return (
    <Dialog onClose={onClose} aria-labelledby="customized-dialog-title" open={open} fullWidth maxWidth="xs">
      <DialogTitle>
        <Typography variant="h5" component="span">
          {initialValues && initialValues.id ? 'Atualizando Categoria' : 'Criando Categoria'}
        </Typography>
      </DialogTitle>

      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={myHandleSubmit}
      >
        {({ dirty, isSubmitting }) => (
          <Form>
            <DialogContent dividers>
              <Box display="flex" flexDirection="row">
                <FormTextField fullWidth type="text" label="Nome" name="name" />
              </Box>
            </DialogContent>

            <DialogActions
              classes={{
                root: classes.actionsRoot,
              }}
            >
              <Button variant="outlined" onClick={() => onClose()}>
                Fechar
              </Button>
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disabled={(!dirty && !defaultName) || isSubmitting}
              >
                Salvar
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default ServiceCategoryFormModal;
